import { render, staticRenderFns } from "./ProductPanel.vue?vue&type=template&id=4f1c9a94&scoped=true&"
import script from "./ProductPanel.vue?vue&type=script&lang=ts&"
export * from "./ProductPanel.vue?vue&type=script&lang=ts&"
import style0 from "./ProductPanel.vue?vue&type=style&index=0&id=4f1c9a94&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1c9a94",
  null
  
)

export default component.exports